<template>
  <div v-if="user">
    <div class="columns is-gapless is-vcentered is-border-bottom has-background-light is-minH50p is-marginless">
      <div class="column is-padding-left">
        <span class="is-size-6">{{ userContactsCount }} Contact(s)</span>
      </div>
      <div class="column is-narrow is-border-left is-self-stretched">
        <router-link
          :to="{name: 'ContactCreate', query: {seller: user.pk}}"
          class="button is-radiusless is-small is-primary is-minH100">
          <span class="icon is-medium"><i class="fal fa-users-medical"></i></span><span class="has-text-weight-medium">Créer un nouveau contact</span>
        </router-link>
      </div>
    </div>

    <table
      class="table is-fullwidth is-marginless has-cells-vcentered"
      v-if="userContacts && userContacts.length">
      <thead>
        <tr class="is-size-6">
          <th>Contact(s)</th>
          <th>Email</th>
          <th>Téléphone</th>
          <th>Ville</th>
        </tr>
      </thead>
      <tbody class="is-size-6">
        <tr
          v-for="(contact, i) in userContacts"
          :key="contact.pk">
          <td class="is-cell-hoverable">
            <router-link
              :to="{name: 'ContactVue', params: {id: contact.pk}}"
              class="fullLink">
              <avatar
                :item="contact"
                :i="i"
                class="is-margin-right-xsmall"></avatar>
              <span>{{ contact.last_name }} {{ contact.first_name }}</span>
            </router-link>
          </td>
          <td><span v-if="contact.email">{{ contact.email }}</span><span v-else>--</span></td>
          <td>
            <phone-number
              v-if="contact.phone"
              :phone="contact.phone"></phone-number><span v-else>--</span>
          </td>
          <td><span v-if="contact.address && contact.address.city">{{ contact.address.city }}</span><span v-else>--</span></td>
        </tr>
      </tbody>
    </table>
    <div class="columns is-gapless">
      <div
        class="is-border-top is-border-right column is-6"
        v-if="userContactsPages > 1 && userContactsPage < userContactsPages">
        <a
          class="button is-light is-fullwidth has-text-grey"
          @click="goToContactListFiltered()"
          v-if="!loadingContact">
          <span class="is-size-6">Afficher tous les contacts</span>
        </a>
        <div
          class="has-text-centered"
          v-else>
          <img
            src="/img/loading/spinner2.svg"
            alt="spinner"
            style="height: 38px">
        </div>
      </div>
      <div
        class="is-border-top column is-6"
        v-if="userContactsPages > 1 && userContactsPage < userContactsPages">
        <a
          class="button is-light is-fullwidth has-text-grey"
          @click="loadMoreContact(userContactsPage, user.pk)"
          v-if="!loadingContact">
          <span class="icon is-small is-size-6"><i class="fas fa-chevron-down"></i></span>
          <span class="is-size-6">Afficher plus de contacts</span>
        </a>
        <div
          class="has-text-centered"
          v-else>
          <img
            src="/img/loading/spinner2.svg"
            alt="spinner"
            style="height: 38px">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { User } from '@/mixins'

export default {
  name: 'UserContactList',
  mixins: [User],
  props: {
    propsTab: String
  },
  methods: {
    goToContactListFiltered () {
      let query = {
        user: Object.assign({}, this.user)
      }
      this.$router.replace({ name: 'ContactList', query })
    }
  }
}
</script>
